import { SurveysList as SurveysListComponent } from './SurveysList.component';
import { connector } from './SurveysList.connector';

export const SurveysList = connector(SurveysListComponent);
